import React from 'react'

const WizardStep = ({ stepNumber, title, description, children, completed }) => {
    return (
        <div className="space-y-4">
            <div className="flex items-center gap-3">
                <div className={`w-10 h-10 rounded-full flex items-center justify-center font-bold text-white ${
                    completed ? 'bg-emerald-500' : 'bg-blue-500'
                }`}>
                    {completed ? '✓' : stepNumber}
                </div>
                <div>
                    <h3 className="text-lg font-semibold">{title}</h3>
                    <p className="text-sm text-gray-600 dark:text-gray-400">{description}</p>
                </div>
            </div>
            <div className="bg-gray-50 dark:bg-gray-700/30 rounded-lg p-6">
                {children}
            </div>
        </div>
    );
};

export default WizardStep
